<mat-toolbar>
  <mat-toolbar-row>
    <img class="title-img" alt="Logo" [style]="CUSTOMIZATION.headerLogoStyle" [src]="CUSTOMIZATION.headerLogoUrl"
         [routerLink]="['/']">
    <span class="flex"></span>
    <button mat-icon-button [matMenuTriggerFor]="languagesMenu">
      <mat-icon>language</mat-icon>
    </button>
    <mat-menu #languagesMenu>
      <ng-template matMenuContent>
        @for (language of LANGUAGES; track language) {
        <button mat-menu-item [disabled]="language === translate.currentLang"
                (click)="translate.use(language)">
          {{'UI_LANGUAGES.' + language | translate}}
        </button>
        }
      </ng-template>
    </mat-menu>
    @if (auth.isAuthenticated()) {
      @if (profile$ | async; as profile) {
        <button class="profile-button" mat-button [matMenuTriggerFor]="menu">
          <img alt="user avatar" fsAvatar [profileId]="profile.userid"/>
          <span class="username">{{profile.username}} </span>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="logout()">
            {{'COMMON.BUTTONS.LOGOUT' | translate}}
          </button>
        </mat-menu>
      }
    }
  </mat-toolbar-row>
</mat-toolbar>
